/**
 * Created by richard on 7/14/14.
 */
var askSchoolSpecificQuestionsModel = angular.module('askSchoolSpecificQuestionsModel', ['schoolModel']);
askSchoolSpecificQuestionsModel.factory('AskSchoolSpecificQuestionsModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory){
    var AskSchoolSpecificQuestionsModel = function(){
        this.endpoint = "/ExtraQuestions";
        this.primaryKey = "recordID";
    }
    AskSchoolSpecificQuestionsModel.prototype = new SchoolModelFactory();
    AskSchoolSpecificQuestionsModel.prototype.parent = SchoolModelFactory.prototype; 
    /*AskSchoolSpecificQuestionsModel.prototype.resolveData = function(schoolID)
    {
        var parent = this;
        return this.parent.resolveData.apply(this, arguments).then(function(data)
        {
            parent.data = data[0].data;
        });

    }*/
    AskSchoolSpecificQuestionsModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        var question = {schoolID: schoolID, Active: 0, DD1: '', DD2: '', DD3: '', DD4: '', DD5: '', DD6: '', DD7: '',
                        DD8: '', Desc_Box: '', No_text: '', Q_type: '', Question: '', Yes_text: '',
                        approved: 0, money: '', questionOrder: '', required: '', deleted: 0};                
        return (this.data.push(question))-1;

    }
    
    return AskSchoolSpecificQuestionsModel;
});


askSchoolSpecificQuestionsModel.service('AskSchoolSpecificQuestionsModelService', function(AskSchoolSpecificQuestionsModelFactory){
    var askSchoolSpecificQuestionsModel = new AskSchoolSpecificQuestionsModelFactory();
    return askSchoolSpecificQuestionsModel;
});


